import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'info-icon',
  templateUrl: './info-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InfoIconComponent {}
